var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { SelectableNavigationItem } from '../../../../model/selectable-navigation-item';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { EmitterConstants } from '../../../../shared/emitter-constants';
import { Emitter } from '../../../../shared/utils/emitter/emitter';
import { Trial } from '../../../../model/trial';
import { takeUntil } from 'rxjs/operators';
import { TvshopConstants } from '../../../../shared/tvshop-constants';
import { DtvCatalogUtils } from '../../../../utils/dtv-catalog/dtv-catalog.utils';
import { OmapiIdsUtils } from '../../../../shared/utils/omapi-ids/omapi-ids-utils';
import { UserTypeConstants } from '../../../../shared/user-type-constants';
import { OcapiSynchronousService } from '../../../../services/ocapi/ocapi.synchronous.service';
import { OcapiAsynchronousService } from '../../../../services/ocapi/ocapi.asynchronous.service';
import { TvShopStateService } from '../../../../services/state/tv-shop-state.service';
var TrialComparisonButtonComponent = /** @class */ (function (_super) {
    __extends(TrialComparisonButtonComponent, _super);
    function TrialComparisonButtonComponent(navigationService, changeDetection, ocapiSynchronousService, stateService, ocapiAsynchronousService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.changeDetection = changeDetection;
        _this.ocapiSynchronousService = ocapiSynchronousService;
        _this.stateService = stateService;
        _this.ocapiAsynchronousService = ocapiAsynchronousService;
        _this.emitTrialTimeOut = new EventEmitter();
        _this.emitActivationPending = new EventEmitter();
        _this.emitTrialActivation = new EventEmitter();
        _this.isPending = false;
        return _this;
    }
    TrialComparisonButtonComponent.prototype.ngOnInit = function () {
        this.navigationService.registerNavigation(this, this.ownerComponent);
    };
    TrialComparisonButtonComponent.prototype.onBack = function () {
        this.onEmitSetPending(false);
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.ownerComponent);
    };
    TrialComparisonButtonComponent.prototype.onEnter = function () {
        var _this = this;
        if (this.trial && !this.isPending) {
            this.onEmitSetPending(true);
            this.onEmitSetTrialActivation();
            var activateTrialObservable = void 0;
            if (OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER) {
                activateTrialObservable = this.ocapiAsynchronousService.activateTrial(this.trial);
            }
            else if (OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER) {
                activateTrialObservable = this.ocapiSynchronousService.activateTrial(this.trial);
            }
            var activateTrial = activateTrialObservable
                .pipe(takeUntil(this.stopSubscription))
                .subscribe(function (response) {
                if (response.success) {
                    _this.onEmitSetPending(false);
                    Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL).emit(_this.trial);
                    var packs = _this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
                    DtvCatalogUtils.onTrialActivated(packs, _this.trial);
                    _this.stateService.setTvShopEntertainmentPacks(packs);
                }
                else {
                    _this.onEmitSetPending(false);
                    _this.onBack();
                    _this.containsErrors('Trial could not be activated', response);
                }
            }, function (error1) {
                _this.onEmitSetPending(false);
                _this.onBack();
                _this.containsErrors('Trial could not be activated', error1);
            });
            this.activateTimeout(activateTrial);
            this.onEmitSetPending(this.isPending);
        }
    };
    TrialComparisonButtonComponent.prototype.activate = function (active) {
        this.active = active;
        this.changeDetection.detectChanges();
    };
    TrialComparisonButtonComponent.prototype.onEmitSetPending = function (isPending) {
        this.isPending = isPending;
        this.emitActivationPending.emit(isPending);
    };
    TrialComparisonButtonComponent.prototype.onEmitTrialTimeOut = function (isTimeout) {
        this.emitTrialTimeOut.emit(isTimeout);
    };
    TrialComparisonButtonComponent.prototype.onEmitSetTrialActivation = function () {
        this.emitTrialActivation.emit(this.trial);
    };
    TrialComparisonButtonComponent.prototype.activateTimeout = function (activateTrial) {
        var _this = this;
        setTimeout(function () {
            if (_this.isPending) {
                activateTrial.unsubscribe();
                _this.onEmitTrialTimeOut(true);
                _this.onEmitSetPending(false);
            }
        }, TvshopConstants.MAXIMUM_ORDERING_COOL_DOWN_IN_MS);
    };
    return TrialComparisonButtonComponent;
}(SelectableNavigationItem));
export { TrialComparisonButtonComponent };
